import xbytes from 'xbytes'

export default class File {
  icon: string
  name: string
  size: number
  sizeFormated: string
  type: string

  constructor (file: File) {
    this.name = file.name
    this.type = file.type
    this.size = file.size
    this.sizeFormated = xbytes(file.size)
    this.icon = this.setIconBasedOnFileType(file.type)
  }

  setIconBasedOnFileType (fileType: string): string {
    switch (fileType) {
      case 'application/pdf':
        return 'pdf'
      default:
        return 'default'
    }
  }
}
